import { Button, Modal } from "react-bootstrap";

const RemoveEventModal = ({
  show,
  closeEventModal,
  removePreviousEvents,
}: any) => {
  return (
    <Modal show={show} onHide={closeEventModal} centered>
      <Modal.Header closeButton>
        <Modal.Title>Attention!!</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div>
          {
            "You can't add both public and private events to your cart at the same time, so your previous items will be removed."
          }
        </div>
        <div className="d-flex justify-content-end gap-3">
          <div>
            <Button
              style={{
                backgroundColor: "#3F41D1",
                marginTop: "1rem",
              }}
              onClick={() => closeEventModal()}
              type="button"
            >
              CANCEL
            </Button>
          </div>
          <div>
            <Button
              style={{
                backgroundColor: "#3F41D1",
                marginTop: "1rem",
              }}
              onClick={removePreviousEvents}
              type="button"
            >
              PROCEED
            </Button>
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default RemoveEventModal;
